import React from 'react';
import { Badge, Select, SelectProps } from 'antd';

import { TravelMethod, TravelMethodIdType } from 'leash/types';

const { Option } = Select;

interface Props extends SelectProps<TravelMethodIdType> {
  travelMethods: TravelMethod[];
}

export function SelectTravelMethod({
  onChange,
  defaultValue,
  travelMethods,
  loading,
  disabled = false,
}: Props) {
  return (
    <Select
      placeholder={loading ? 'Loading...' : 'Unassigned'}
      value={loading ? undefined : defaultValue}
      onChange={onChange}
      disabled={loading || disabled}
      data-testid="select-travel-method"
      loading={loading}
    >
      {travelMethods.map((travelMethod) => (
        <Option value={travelMethod.id} key={travelMethod.id}>
          <Badge status={travelMethod.isEligible ? 'success' : 'error'} />
          {travelMethod.name}
        </Option>
      ))}
    </Select>
  );
}
